export default {"src":"/_next/static/media/added_to_cart.d59594f3.svg","height":25,"width":24};